if (!customElements.get('sticky-nav')) {
  class StickyNav extends HTMLElement {
    constructor() {
      super();

      this.header = document.querySelector(
        '#shopify-section-header header, .shopify-section-group-header-group header',
      );
      this.navWrapper = this.querySelector('[data-nav-wrapper]');
      this.observer = null;
    }

    connectedCallback() {
      this.init();

      window.addEventListener(
        'resize',
        debounce(() => {
          this.init();
        }, 300).bind(this),
      );
    }

    init() {
      this.createObserver();
      this.setHeight();
    }

    createObserver() {
      if (this.observer) this.observer.disconnect();

      const headerHeight = this.header.offsetHeight;

      this.observer = new IntersectionObserver(
        ([entry]) => {
          if (
            !entry.isIntersecting &&
            entry.boundingClientRect.top <= headerHeight
          ) {
            this.classList.add('is-sticky');
          } else {
            this.classList.remove('is-sticky');
          }
        },
        {
          root: null,
          threshold: 1,
          rootMargin: `-${headerHeight}px 0px 0px 0px`,
        },
      );

      this.observer.observe(this);
    }

    setHeight() {
      document.documentElement.style.setProperty(
        '--sticky-nav-height',
        `${this.navWrapper.offsetHeight}px`,
      );
    }
  }

  customElements.define('sticky-nav', StickyNav);
}
